import { type Item, type ItemDispatchProps, type SetItemsProps } from 'src/types'

// consider adding props that last from game to game
const setItems = ({ items }: SetItemsProps) => items

export const reducer = (items: Record<string, Item>, action: ItemDispatchProps) => {
  switch (action.type) {
    case 'SET_ITEMS':
      return setItems(action)
    default:
      return items
  }
}
